import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../store';
import { removeFromWishlist } from '../../../store/slices/wishlistSlice';
import { addToCartSuccess } from '../../../store/slices/cartSlice';
import { addNotification } from '../../../store/slices/uiSlice';
import './Wishlist.css';
import { DynamicIcon } from '../../../components/common/SvgIcons';

const Wishlist: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state: RootState) => state.auth);
  const { items } = useSelector((state: RootState) => state.wishlist);

  const trendingCategories = [
    { name: "Safety", image: "/assets/images/torch_light.png" },
    { name: "Machine", image: "/assets/images/sewing_machine.png" },
    { name: "Generator", image: "/assets/images/air_compressor.png" },
    { name: "Camera", image: "/assets/images/camera.png" },
    { name: "Cleaner", image: "/assets/images/vacuum_cleaner.png" },
    { name: "Stove", image: "/assets/images/induction_cooktop.png" }
  ];

  const fullName = user ? `${user.firstName} ${user.lastName}` : 'Guest User';

  const handleAddToCart = (product: any) => {
    const imageUrl = product.images && product.images[0] ? product.images[0].url : '';
    dispatch(addToCartSuccess({
      id: `cart_${Date.now()}_${product.id}`,
      productId: product.id,
      quantity: 1,
      addedAt: new Date().toISOString(),
      product: {
        id: product.id,
        name: product.name,
        sku: product.id,
        price: parseFloat(product.price.toString().replace(/[^\d.]/g, '')) || 0,
        discountedPrice: parseFloat(product.price.toString().replace(/[^\d.]/g, '')) || 0,
        currency: 'INR',
        image: imageUrl,
        inStock: true,
        stockQuantity: 10
      }
    }));
    dispatch(addNotification({
      type: 'success',
      title: 'Success',
      message: `"${product.name}" added to cart!`
    }));
  };

  const handleRemove = (productId: string) => {
    dispatch(removeFromWishlist(productId));
  };

  return (
    <div className="account-wishlist-page">
      <div className="account-wishlist-container">
        
        <div className="account-layout">
          
          {/* Sidebar */}
          <aside className="account-sidebar-panel">
            <div className="account-user-header">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="user-icon">
                <path d="M20 21a8 8 0 0 0-16 0"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
              {fullName}
            </div>
            <nav className="account-nav-list">
              <Link to="/account/addresses" className="account-nav-item">
                <span className="icon">⌖</span> My Addresses
              </Link>
              <Link to="/account/orders" className="account-nav-item">
                <span className="icon">▣</span> My Order
              </Link>
              <Link to="/account/rfqs" className="account-nav-item">
                <span className="icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg></span> My RFQ's
              </Link>
              <Link to="/account/business" className="account-nav-item">
                <span className="icon">▤</span> My Business Details
              </Link>
              <Link to="/account/wishlist" className="account-nav-item active">
                <span className="icon green-icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg></span> My Wishlist
              </Link>
              <Link to="/logout" className="account-nav-item">
                <span className="icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg></span> Log-out
              </Link>
            </nav>
          </aside>

          {/* Main Content */}
          <main className="account-main-content">
            
            {items.length > 0 ? (
              <div className="wishlist-items-container" style={{ marginBottom: '30px' }}>
                <h2 style={{ fontSize: '22px', fontWeight: '800', color: '#1e293b', margin: '0 0 20px 0', borderBottom: '2px solid #df2027', paddingBottom: '8px', display: 'inline-block' }}>My Wishlist</h2>
                
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '20px' }}>
                  {items.map((product) => (
                    <div key={product.id} style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', position: 'relative', boxShadow: '0 4px 12px rgba(0,0,0,0.03)', transition: 'transform 0.2s' }}>
                      <button onClick={() => handleRemove(product.id)} style={{ position: 'absolute', top: '10px', right: '10px', background: '#fee2e2', color: '#ef4444', border: 'none', borderRadius: '50%', width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: '16px', fontWeight: 'bold' }} title="Remove from Wishlist">×</button>
                      
                      <div style={{ height: '160px', padding: '15px', background: '#f8fafc', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img src={product.images && product.images[0] ? product.images[0].url : ''} alt={product.name} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                      </div>
                      
                      <div style={{ padding: '15px', display: 'flex', flexDirection: 'column', flex: '1', justifyContent: 'space-between' }}>
                        <div>
                          <span style={{ fontSize: '11px', textTransform: 'uppercase', color: '#df2027', fontWeight: '700', letterSpacing: '0.5px' }}>{product.brand}</span>
                          <h4 style={{ fontSize: '14px', fontWeight: '600', color: '#1e293b', margin: '4px 0 8px 0', height: '36px', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', lineHeight: '1.3' }}>{product.name}</h4>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '10px' }}>
                            <span style={{ background: '#10b981', color: '#fff', fontSize: '10px', fontWeight: '700', padding: '2px 6px', borderRadius: '4px', display: 'flex', alignItems: 'center', gap: '3px' }}><DynamicIcon name="star" size={10} color="currentColor" stroke="currentColor" /> {product.rating}</span>
                            <span style={{ fontSize: '11px', color: '#64748b' }}>({product.reviewCount || 0} reviews)</span>
                          </div>
                        </div>
                        
                        <div>
                          <div style={{ fontSize: '16px', fontWeight: '800', color: '#df2027', marginBottom: '12px' }}>₹{product.price.toLocaleString('en-IN')}</div>
                          <button onClick={() => handleAddToCart(product)} style={{ width: '100%', background: '#df2027', color: '#fff', border: 'none', padding: '10px', borderRadius: '6px', fontWeight: '700', fontSize: '12px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
                            ADD TO CART
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              /* Empty Wishlist Banner */
              <div className="empty-wishlist-banner">
                <div className="empty-wishlist-image-container">
                  <img src="/assets/images/wishlist.png" alt="Empty Wishlist" />
                </div>
                <div className="empty-wishlist-details">
                  <h2>Your Wishlist is empty!</h2>
                  <p>Explore more & shortlist your favourite items.<br/>Review them anytime and add to cart</p>
                  <button className="start-shopping-btn" onClick={() => navigate('/')}>
                    Continue Shopping
                  </button>
                </div>
              </div>
            )}

            {/* Trending Categories Section */}
            <div className="wishlist-trending-categories">
              <h3>Trending Categories</h3>
              <div className="trending-categories-grid">
                {trendingCategories.map((cat, idx) => (
                  <div key={idx} className="trending-category-square-card">
                    <div className="trending-img-box">
                      <img src={cat.image} alt={cat.name} />
                    </div>
                    <div className="trending-name-box">
                      <span>{cat.name}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </main>
        </div>
      </div>
    </div>
  );
};

export default Wishlist;
